import _slicedToArray from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _classCallCheck from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _inherits from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _createSuper from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createSuper";
// @generated by protobuf-ts 2.8.0 with parameter add_pb_suffix,long_type_string,output_javascript_es2015
// @generated from protobuf file "grpc/txauth/txauth_api.proto" (package "grpc.txauth", syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.8.0 with parameter add_pb_suffix,long_type_string,output_javascript_es2015
// @generated from protobuf file "grpc/txauth/txauth_api.proto" (package "grpc.txauth", syntax proto3)
// tslint:disable
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { LoggedDevice } from "@finam/tx-proto-grpc-txauth-common/proto/txauth/common/device/devices_pb";
import { AuthProvider } from "@finam/tx-proto-grpc-txauth-common/proto/txauth/common/provider/provider_pb";
import { Status } from "@finam/tx-proto-grpc-proto/google/rpc/status_pb";
import { Duration } from "@finam/tx-proto-lib-google-wellknown/google/protobuf/duration_pb";
import { TokenScope } from "@finam/tx-proto-grpc-txauth-common/proto/txauth/common/token/token_scope_pb";
import { Device } from "@finam/tx-proto-grpc-txauth-common/proto/txauth/common/device/devices_pb"; // @generated message type with reflection information, may provide speed optimized methods

var AuthRequest$Type = /*#__PURE__*/function (_MessageType) {
  _inherits(AuthRequest$Type, _MessageType);

  var _super = _createSuper(AuthRequest$Type);

  function AuthRequest$Type() {
    _classCallCheck(this, AuthRequest$Type);

    return _super.call(this, "grpc.txauth.AuthRequest", [{
      no: 1,
      name: "provider",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 2,
      name: "login",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 3,
      name: "password",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 4,
      name: "device",
      kind: "message",
      T: function T() {
        return Device;
      }
    }, {
      no: 5,
      name: "token_scope",
      kind: "message",
      T: function T() {
        return TokenScope;
      }
    }, {
      no: 6,
      name: "token_total_expiration",
      kind: "message",
      T: function T() {
        return Duration;
      }
    }]);
  }

  _createClass(AuthRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        provider: "",
        login: "",
        password: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag = reader.tag(),
            _reader$tag2 = _slicedToArray(_reader$tag, 2),
            fieldNo = _reader$tag2[0],
            wireType = _reader$tag2[1];

        switch (fieldNo) {
          case
          /* string provider */
          1:
            message.provider = reader.string();
            break;

          case
          /* string login */
          2:
            message.login = reader.string();
            break;

          case
          /* string password */
          3:
            message.password = reader.string();
            break;

          case
          /* proto.txauth.common.device.Device device */
          4:
            message.device = Device.internalBinaryRead(reader, reader.uint32(), options, message.device);
            break;

          case
          /* proto.txauth.common.token.TokenScope token_scope */
          5:
            message.tokenScope = TokenScope.internalBinaryRead(reader, reader.uint32(), options, message.tokenScope);
            break;

          case
          /* google.protobuf.Duration token_total_expiration */
          6:
            message.tokenTotalExpiration = Duration.internalBinaryRead(reader, reader.uint32(), options, message.tokenTotalExpiration);
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string provider = 1; */
      if (message.provider !== "") writer.tag(1, WireType.LengthDelimited).string(message.provider);
      /* string login = 2; */

      if (message.login !== "") writer.tag(2, WireType.LengthDelimited).string(message.login);
      /* string password = 3; */

      if (message.password !== "") writer.tag(3, WireType.LengthDelimited).string(message.password);
      /* proto.txauth.common.device.Device device = 4; */

      if (message.device) Device.internalBinaryWrite(message.device, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
      /* proto.txauth.common.token.TokenScope token_scope = 5; */

      if (message.tokenScope) TokenScope.internalBinaryWrite(message.tokenScope, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
      /* google.protobuf.Duration token_total_expiration = 6; */

      if (message.tokenTotalExpiration) Duration.internalBinaryWrite(message.tokenTotalExpiration, writer.tag(6, WireType.LengthDelimited).fork(), options).join();
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return AuthRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.AuthRequest
 */


export var AuthRequest = new AuthRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var RenewRequest$Type = /*#__PURE__*/function (_MessageType2) {
  _inherits(RenewRequest$Type, _MessageType2);

  var _super2 = _createSuper(RenewRequest$Type);

  function RenewRequest$Type() {
    _classCallCheck(this, RenewRequest$Type);

    return _super2.call(this, "grpc.txauth.RenewRequest", [{
      no: 1,
      name: "token",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 2,
      name: "device",
      kind: "message",
      T: function T() {
        return Device;
      }
    }, {
      no: 3,
      name: "code",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 4,
      name: "force",
      kind: "scalar",
      T: 8
      /*ScalarType.BOOL*/

    }, {
      no: 5,
      name: "token_scope",
      kind: "message",
      T: function T() {
        return TokenScope;
      }
    }]);
  }

  _createClass(RenewRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        token: "",
        code: "",
        force: false
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag3 = reader.tag(),
            _reader$tag4 = _slicedToArray(_reader$tag3, 2),
            fieldNo = _reader$tag4[0],
            wireType = _reader$tag4[1];

        switch (fieldNo) {
          case
          /* string token */
          1:
            message.token = reader.string();
            break;

          case
          /* proto.txauth.common.device.Device device */
          2:
            message.device = Device.internalBinaryRead(reader, reader.uint32(), options, message.device);
            break;

          case
          /* string code */
          3:
            message.code = reader.string();
            break;

          case
          /* bool force */
          4:
            message.force = reader.bool();
            break;

          case
          /* proto.txauth.common.token.TokenScope token_scope */
          5:
            message.tokenScope = TokenScope.internalBinaryRead(reader, reader.uint32(), options, message.tokenScope);
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string token = 1; */
      if (message.token !== "") writer.tag(1, WireType.LengthDelimited).string(message.token);
      /* proto.txauth.common.device.Device device = 2; */

      if (message.device) Device.internalBinaryWrite(message.device, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
      /* string code = 3; */

      if (message.code !== "") writer.tag(3, WireType.LengthDelimited).string(message.code);
      /* bool force = 4; */

      if (message.force !== false) writer.tag(4, WireType.Varint).bool(message.force);
      /* proto.txauth.common.token.TokenScope token_scope = 5; */

      if (message.tokenScope) TokenScope.internalBinaryWrite(message.tokenScope, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return RenewRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.RenewRequest
 */


export var RenewRequest = new RenewRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var TokenResponse$Type = /*#__PURE__*/function (_MessageType3) {
  _inherits(TokenResponse$Type, _MessageType3);

  var _super3 = _createSuper(TokenResponse$Type);

  function TokenResponse$Type() {
    _classCallCheck(this, TokenResponse$Type);

    return _super3.call(this, "grpc.txauth.TokenResponse", [{
      no: 1,
      name: "status",
      kind: "message",
      T: function T() {
        return Status;
      }
    }, {
      no: 2,
      name: "token",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(TokenResponse$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        token: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag5 = reader.tag(),
            _reader$tag6 = _slicedToArray(_reader$tag5, 2),
            fieldNo = _reader$tag6[0],
            wireType = _reader$tag6[1];

        switch (fieldNo) {
          case
          /* google.rpc.Status status */
          1:
            message.status = Status.internalBinaryRead(reader, reader.uint32(), options, message.status);
            break;

          case
          /* string token */
          2:
            message.token = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* google.rpc.Status status = 1; */
      if (message.status) Status.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
      /* string token = 2; */

      if (message.token !== "") writer.tag(2, WireType.LengthDelimited).string(message.token);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return TokenResponse$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.TokenResponse
 */


export var TokenResponse = new TokenResponse$Type(); // @generated message type with reflection information, may provide speed optimized methods

var AuthProvidersRequest$Type = /*#__PURE__*/function (_MessageType4) {
  _inherits(AuthProvidersRequest$Type, _MessageType4);

  var _super4 = _createSuper(AuthProvidersRequest$Type);

  function AuthProvidersRequest$Type() {
    _classCallCheck(this, AuthProvidersRequest$Type);

    return _super4.call(this, "grpc.txauth.AuthProvidersRequest", []);
  }

  _createClass(AuthProvidersRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {};
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      return target !== null && target !== void 0 ? target : this.create();
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return AuthProvidersRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.AuthProvidersRequest
 */


export var AuthProvidersRequest = new AuthProvidersRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var AuthProvidersResponse$Type = /*#__PURE__*/function (_MessageType5) {
  _inherits(AuthProvidersResponse$Type, _MessageType5);

  var _super5 = _createSuper(AuthProvidersResponse$Type);

  function AuthProvidersResponse$Type() {
    _classCallCheck(this, AuthProvidersResponse$Type);

    return _super5.call(this, "grpc.txauth.AuthProvidersResponse", [{
      no: 1,
      name: "status",
      kind: "message",
      T: function T() {
        return Status;
      }
    }, {
      no: 2,
      name: "providers",
      kind: "message",
      repeat: 1
      /*RepeatType.PACKED*/
      ,
      T: function T() {
        return AuthProvider;
      }
    }]);
  }

  _createClass(AuthProvidersResponse$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        providers: []
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag7 = reader.tag(),
            _reader$tag8 = _slicedToArray(_reader$tag7, 2),
            fieldNo = _reader$tag8[0],
            wireType = _reader$tag8[1];

        switch (fieldNo) {
          case
          /* google.rpc.Status status */
          1:
            message.status = Status.internalBinaryRead(reader, reader.uint32(), options, message.status);
            break;

          case
          /* repeated proto.txauth.common.provider.AuthProvider providers */
          2:
            message.providers.push(AuthProvider.internalBinaryRead(reader, reader.uint32(), options));
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* google.rpc.Status status = 1; */
      if (message.status) Status.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
      /* repeated proto.txauth.common.provider.AuthProvider providers = 2; */

      for (var i = 0; i < message.providers.length; i++) {
        AuthProvider.internalBinaryWrite(message.providers[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
      }

      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return AuthProvidersResponse$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.AuthProvidersResponse
 */


export var AuthProvidersResponse = new AuthProvidersResponse$Type(); // @generated message type with reflection information, may provide speed optimized methods

var TempLoginRequest$Type = /*#__PURE__*/function (_MessageType6) {
  _inherits(TempLoginRequest$Type, _MessageType6);

  var _super6 = _createSuper(TempLoginRequest$Type);

  function TempLoginRequest$Type() {
    _classCallCheck(this, TempLoginRequest$Type);

    return _super6.call(this, "grpc.txauth.TempLoginRequest", [{
      no: 1,
      name: "record_id",
      kind: "scalar",
      T: 3
      /*ScalarType.INT64*/

    }, {
      no: 2,
      name: "admin_device",
      kind: "message",
      T: function T() {
        return Device;
      }
    }]);
  }

  _createClass(TempLoginRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        recordId: "0"
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag9 = reader.tag(),
            _reader$tag10 = _slicedToArray(_reader$tag9, 2),
            fieldNo = _reader$tag10[0],
            wireType = _reader$tag10[1];

        switch (fieldNo) {
          case
          /* int64 record_id */
          1:
            message.recordId = reader.int64().toString();
            break;

          case
          /* proto.txauth.common.device.Device admin_device */
          2:
            message.adminDevice = Device.internalBinaryRead(reader, reader.uint32(), options, message.adminDevice);
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* int64 record_id = 1; */
      if (message.recordId !== "0") writer.tag(1, WireType.Varint).int64(message.recordId);
      /* proto.txauth.common.device.Device admin_device = 2; */

      if (message.adminDevice) Device.internalBinaryWrite(message.adminDevice, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return TempLoginRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.TempLoginRequest
 */


export var TempLoginRequest = new TempLoginRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var TempLoginResponse$Type = /*#__PURE__*/function (_MessageType7) {
  _inherits(TempLoginResponse$Type, _MessageType7);

  var _super7 = _createSuper(TempLoginResponse$Type);

  function TempLoginResponse$Type() {
    _classCallCheck(this, TempLoginResponse$Type);

    return _super7.call(this, "grpc.txauth.TempLoginResponse", [{
      no: 1,
      name: "status",
      kind: "message",
      T: function T() {
        return Status;
      }
    }, {
      no: 2,
      name: "temp_login",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 3,
      name: "temp_password",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(TempLoginResponse$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        tempLogin: "",
        tempPassword: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag11 = reader.tag(),
            _reader$tag12 = _slicedToArray(_reader$tag11, 2),
            fieldNo = _reader$tag12[0],
            wireType = _reader$tag12[1];

        switch (fieldNo) {
          case
          /* google.rpc.Status status */
          1:
            message.status = Status.internalBinaryRead(reader, reader.uint32(), options, message.status);
            break;

          case
          /* string temp_login */
          2:
            message.tempLogin = reader.string();
            break;

          case
          /* string temp_password */
          3:
            message.tempPassword = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* google.rpc.Status status = 1; */
      if (message.status) Status.internalBinaryWrite(message.status, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
      /* string temp_login = 2; */

      if (message.tempLogin !== "") writer.tag(2, WireType.LengthDelimited).string(message.tempLogin);
      /* string temp_password = 3; */

      if (message.tempPassword !== "") writer.tag(3, WireType.LengthDelimited).string(message.tempPassword);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return TempLoginResponse$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.TempLoginResponse
 */


export var TempLoginResponse = new TempLoginResponse$Type(); // @generated message type with reflection information, may provide speed optimized methods

var GetOneTimeTokenRequest$Type = /*#__PURE__*/function (_MessageType8) {
  _inherits(GetOneTimeTokenRequest$Type, _MessageType8);

  var _super8 = _createSuper(GetOneTimeTokenRequest$Type);

  function GetOneTimeTokenRequest$Type() {
    _classCallCheck(this, GetOneTimeTokenRequest$Type);

    return _super8.call(this, "grpc.txauth.GetOneTimeTokenRequest", [{
      no: 1,
      name: "token",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 2,
      name: "provider",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 3,
      name: "token_scope",
      kind: "message",
      T: function T() {
        return TokenScope;
      }
    }]);
  }

  _createClass(GetOneTimeTokenRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        token: "",
        provider: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag13 = reader.tag(),
            _reader$tag14 = _slicedToArray(_reader$tag13, 2),
            fieldNo = _reader$tag14[0],
            wireType = _reader$tag14[1];

        switch (fieldNo) {
          case
          /* string token */
          1:
            message.token = reader.string();
            break;

          case
          /* string provider */
          2:
            message.provider = reader.string();
            break;

          case
          /* proto.txauth.common.token.TokenScope token_scope */
          3:
            message.tokenScope = TokenScope.internalBinaryRead(reader, reader.uint32(), options, message.tokenScope);
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string token = 1; */
      if (message.token !== "") writer.tag(1, WireType.LengthDelimited).string(message.token);
      /* string provider = 2; */

      if (message.provider !== "") writer.tag(2, WireType.LengthDelimited).string(message.provider);
      /* proto.txauth.common.token.TokenScope token_scope = 3; */

      if (message.tokenScope) TokenScope.internalBinaryWrite(message.tokenScope, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return GetOneTimeTokenRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.GetOneTimeTokenRequest
 */


export var GetOneTimeTokenRequest = new GetOneTimeTokenRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var GetOneTimeTokenResponse$Type = /*#__PURE__*/function (_MessageType9) {
  _inherits(GetOneTimeTokenResponse$Type, _MessageType9);

  var _super9 = _createSuper(GetOneTimeTokenResponse$Type);

  function GetOneTimeTokenResponse$Type() {
    _classCallCheck(this, GetOneTimeTokenResponse$Type);

    return _super9.call(this, "grpc.txauth.GetOneTimeTokenResponse", [{
      no: 1,
      name: "token",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(GetOneTimeTokenResponse$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        token: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag15 = reader.tag(),
            _reader$tag16 = _slicedToArray(_reader$tag15, 2),
            fieldNo = _reader$tag16[0],
            wireType = _reader$tag16[1];

        switch (fieldNo) {
          case
          /* string token */
          1:
            message.token = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string token = 1; */
      if (message.token !== "") writer.tag(1, WireType.LengthDelimited).string(message.token);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return GetOneTimeTokenResponse$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.GetOneTimeTokenResponse
 */


export var GetOneTimeTokenResponse = new GetOneTimeTokenResponse$Type(); // @generated message type with reflection information, may provide speed optimized methods

var ExchangeOneTimeTokenRequest$Type = /*#__PURE__*/function (_MessageType10) {
  _inherits(ExchangeOneTimeTokenRequest$Type, _MessageType10);

  var _super10 = _createSuper(ExchangeOneTimeTokenRequest$Type);

  function ExchangeOneTimeTokenRequest$Type() {
    _classCallCheck(this, ExchangeOneTimeTokenRequest$Type);

    return _super10.call(this, "grpc.txauth.ExchangeOneTimeTokenRequest", [{
      no: 1,
      name: "token",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }, {
      no: 2,
      name: "device",
      kind: "message",
      T: function T() {
        return Device;
      }
    }, {
      no: 4,
      name: "provider",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(ExchangeOneTimeTokenRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        token: "",
        provider: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag17 = reader.tag(),
            _reader$tag18 = _slicedToArray(_reader$tag17, 2),
            fieldNo = _reader$tag18[0],
            wireType = _reader$tag18[1];

        switch (fieldNo) {
          case
          /* string token */
          1:
            message.token = reader.string();
            break;

          case
          /* proto.txauth.common.device.Device device */
          2:
            message.device = Device.internalBinaryRead(reader, reader.uint32(), options, message.device);
            break;

          case
          /* string provider */
          4:
            message.provider = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string token = 1; */
      if (message.token !== "") writer.tag(1, WireType.LengthDelimited).string(message.token);
      /* proto.txauth.common.device.Device device = 2; */

      if (message.device) Device.internalBinaryWrite(message.device, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
      /* string provider = 4; */

      if (message.provider !== "") writer.tag(4, WireType.LengthDelimited).string(message.provider);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return ExchangeOneTimeTokenRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.ExchangeOneTimeTokenRequest
 */


export var ExchangeOneTimeTokenRequest = new ExchangeOneTimeTokenRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var ExchangeOneTimeTokenResponse$Type = /*#__PURE__*/function (_MessageType11) {
  _inherits(ExchangeOneTimeTokenResponse$Type, _MessageType11);

  var _super11 = _createSuper(ExchangeOneTimeTokenResponse$Type);

  function ExchangeOneTimeTokenResponse$Type() {
    _classCallCheck(this, ExchangeOneTimeTokenResponse$Type);

    return _super11.call(this, "grpc.txauth.ExchangeOneTimeTokenResponse", [{
      no: 1,
      name: "token",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(ExchangeOneTimeTokenResponse$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        token: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag19 = reader.tag(),
            _reader$tag20 = _slicedToArray(_reader$tag19, 2),
            fieldNo = _reader$tag20[0],
            wireType = _reader$tag20[1];

        switch (fieldNo) {
          case
          /* string token */
          1:
            message.token = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string token = 1; */
      if (message.token !== "") writer.tag(1, WireType.LengthDelimited).string(message.token);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return ExchangeOneTimeTokenResponse$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.ExchangeOneTimeTokenResponse
 */


export var ExchangeOneTimeTokenResponse = new ExchangeOneTimeTokenResponse$Type(); // @generated message type with reflection information, may provide speed optimized methods

var AutologinRequest$Type = /*#__PURE__*/function (_MessageType12) {
  _inherits(AutologinRequest$Type, _MessageType12);

  var _super12 = _createSuper(AutologinRequest$Type);

  function AutologinRequest$Type() {
    _classCallCheck(this, AutologinRequest$Type);

    return _super12.call(this, "grpc.txauth.AutologinRequest", [{
      no: 1,
      name: "route",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(AutologinRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        route: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag21 = reader.tag(),
            _reader$tag22 = _slicedToArray(_reader$tag21, 2),
            fieldNo = _reader$tag22[0],
            wireType = _reader$tag22[1];

        switch (fieldNo) {
          case
          /* string route */
          1:
            message.route = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string route = 1; */
      if (message.route !== "") writer.tag(1, WireType.LengthDelimited).string(message.route);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return AutologinRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.AutologinRequest
 */


export var AutologinRequest = new AutologinRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var AutologinResponse$Type = /*#__PURE__*/function (_MessageType13) {
  _inherits(AutologinResponse$Type, _MessageType13);

  var _super13 = _createSuper(AutologinResponse$Type);

  function AutologinResponse$Type() {
    _classCallCheck(this, AutologinResponse$Type);

    return _super13.call(this, "grpc.txauth.AutologinResponse", [{
      no: 1,
      name: "url",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(AutologinResponse$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        url: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag23 = reader.tag(),
            _reader$tag24 = _slicedToArray(_reader$tag23, 2),
            fieldNo = _reader$tag24[0],
            wireType = _reader$tag24[1];

        switch (fieldNo) {
          case
          /* string url */
          1:
            message.url = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string url = 1; */
      if (message.url !== "") writer.tag(1, WireType.LengthDelimited).string(message.url);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return AutologinResponse$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.AutologinResponse
 */


export var AutologinResponse = new AutologinResponse$Type(); // @generated message type with reflection information, may provide speed optimized methods

var LogoutDeviceRequest$Type = /*#__PURE__*/function (_MessageType14) {
  _inherits(LogoutDeviceRequest$Type, _MessageType14);

  var _super14 = _createSuper(LogoutDeviceRequest$Type);

  function LogoutDeviceRequest$Type() {
    _classCallCheck(this, LogoutDeviceRequest$Type);

    return _super14.call(this, "grpc.txauth.LogoutDeviceRequest", [{
      no: 2,
      name: "key_id",
      kind: "scalar",
      T: 9
      /*ScalarType.STRING*/

    }]);
  }

  _createClass(LogoutDeviceRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        keyId: ""
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag25 = reader.tag(),
            _reader$tag26 = _slicedToArray(_reader$tag25, 2),
            fieldNo = _reader$tag26[0],
            wireType = _reader$tag26[1];

        switch (fieldNo) {
          case
          /* string key_id */
          2:
            message.keyId = reader.string();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* string key_id = 2; */
      if (message.keyId !== "") writer.tag(2, WireType.LengthDelimited).string(message.keyId);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return LogoutDeviceRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.LogoutDeviceRequest
 */


export var LogoutDeviceRequest = new LogoutDeviceRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var LogoutDeviceResponse$Type = /*#__PURE__*/function (_MessageType15) {
  _inherits(LogoutDeviceResponse$Type, _MessageType15);

  var _super15 = _createSuper(LogoutDeviceResponse$Type);

  function LogoutDeviceResponse$Type() {
    _classCallCheck(this, LogoutDeviceResponse$Type);

    return _super15.call(this, "grpc.txauth.LogoutDeviceResponse", []);
  }

  _createClass(LogoutDeviceResponse$Type, [{
    key: "create",
    value: function create(value) {
      var message = {};
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      return target !== null && target !== void 0 ? target : this.create();
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return LogoutDeviceResponse$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.LogoutDeviceResponse
 */


export var LogoutDeviceResponse = new LogoutDeviceResponse$Type(); // @generated message type with reflection information, may provide speed optimized methods

var LoggedDevicesRequest$Type = /*#__PURE__*/function (_MessageType16) {
  _inherits(LoggedDevicesRequest$Type, _MessageType16);

  var _super16 = _createSuper(LoggedDevicesRequest$Type);

  function LoggedDevicesRequest$Type() {
    _classCallCheck(this, LoggedDevicesRequest$Type);

    return _super16.call(this, "grpc.txauth.LoggedDevicesRequest", [{
      no: 1,
      name: "verified_only",
      kind: "scalar",
      T: 8
      /*ScalarType.BOOL*/

    }]);
  }

  _createClass(LoggedDevicesRequest$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        verifiedOnly: false
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag27 = reader.tag(),
            _reader$tag28 = _slicedToArray(_reader$tag27, 2),
            fieldNo = _reader$tag28[0],
            wireType = _reader$tag28[1];

        switch (fieldNo) {
          case
          /* bool verified_only */
          1:
            message.verifiedOnly = reader.bool();
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* bool verified_only = 1; */
      if (message.verifiedOnly !== false) writer.tag(1, WireType.Varint).bool(message.verifiedOnly);
      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return LoggedDevicesRequest$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.LoggedDevicesRequest
 */


export var LoggedDevicesRequest = new LoggedDevicesRequest$Type(); // @generated message type with reflection information, may provide speed optimized methods

var LoggedDevicesResponse$Type = /*#__PURE__*/function (_MessageType17) {
  _inherits(LoggedDevicesResponse$Type, _MessageType17);

  var _super17 = _createSuper(LoggedDevicesResponse$Type);

  function LoggedDevicesResponse$Type() {
    _classCallCheck(this, LoggedDevicesResponse$Type);

    return _super17.call(this, "grpc.txauth.LoggedDevicesResponse", [{
      no: 1,
      name: "devices",
      kind: "message",
      repeat: 1
      /*RepeatType.PACKED*/
      ,
      T: function T() {
        return LoggedDevice;
      }
    }]);
  }

  _createClass(LoggedDevicesResponse$Type, [{
    key: "create",
    value: function create(value) {
      var message = {
        devices: []
      };
      if (value !== undefined) reflectionMergePartial(this, message, value);
      return message;
    }
  }, {
    key: "internalBinaryRead",
    value: function internalBinaryRead(reader, length, options, target) {
      var message = target !== null && target !== void 0 ? target : this.create(),
          end = reader.pos + length;

      while (reader.pos < end) {
        var _reader$tag29 = reader.tag(),
            _reader$tag30 = _slicedToArray(_reader$tag29, 2),
            fieldNo = _reader$tag30[0],
            wireType = _reader$tag30[1];

        switch (fieldNo) {
          case
          /* repeated proto.txauth.common.device.LoggedDevice devices */
          1:
            message.devices.push(LoggedDevice.internalBinaryRead(reader, reader.uint32(), options));
            break;

          default:
            var u = options.readUnknownField;
            if (u === "throw") throw new globalThis.Error("Unknown field ".concat(fieldNo, " (wire type ").concat(wireType, ") for ").concat(this.typeName));
            var d = reader.skip(wireType);
            if (u !== false) (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
        }
      }

      return message;
    }
  }, {
    key: "internalBinaryWrite",
    value: function internalBinaryWrite(message, writer, options) {
      /* repeated proto.txauth.common.device.LoggedDevice devices = 1; */
      for (var i = 0; i < message.devices.length; i++) {
        LoggedDevice.internalBinaryWrite(message.devices[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
      }

      var u = options.writeUnknownFields;
      if (u !== false) (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
      return writer;
    }
  }]);

  return LoggedDevicesResponse$Type;
}(MessageType);
/**
 * @generated MessageType for protobuf message grpc.txauth.LoggedDevicesResponse
 */


export var LoggedDevicesResponse = new LoggedDevicesResponse$Type();
/**
 * @generated ServiceType for protobuf service grpc.txauth.TxAuthApi
 */

export var TxAuthApi = new ServiceType("grpc.txauth.TxAuthApi", [{
  name: "Auth",
  options: {
    "google.api.http": {
      post: "/grpc-json/txauth/v3/auth/{provider}/{login}",
      body: "*"
    }
  },
  I: AuthRequest,
  O: TokenResponse
}, {
  name: "Renew",
  options: {
    "google.api.http": {
      post: "/grpc-json/txauth/v3/renew",
      body: "*"
    }
  },
  I: RenewRequest,
  O: TokenResponse
}, {
  name: "GetLoggedDevices",
  serverStreaming: true,
  options: {
    "google.api.http": {
      post: "/grpc-json/txauth/v3/getloggeddevices",
      body: "*"
    }
  },
  I: LoggedDevicesRequest,
  O: LoggedDevicesResponse
}, {
  name: "LogoutDevice",
  options: {
    "google.api.http": {
      delete: "/grpc-json/txauth/v3/logoutdevice/{key_id}"
    }
  },
  I: LogoutDeviceRequest,
  O: LogoutDeviceResponse
}, {
  name: "Providers",
  options: {
    "google.api.http": {
      get: "/grpc-json/txauth/v3/providers"
    }
  },
  I: AuthProvidersRequest,
  O: AuthProvidersResponse
}, {
  name: "TempLogin",
  options: {
    "google.api.http": {
      post: "/grpc-json/txauth/v3/templogin/{record_id}",
      body: "*"
    }
  },
  I: TempLoginRequest,
  O: TempLoginResponse
}, {
  name: "OneTimeToken",
  options: {
    "google.api.http": {
      post: "/grpc-json/txauth/v3/onetimetoken",
      body: "*"
    }
  },
  I: GetOneTimeTokenRequest,
  O: GetOneTimeTokenResponse
}, {
  name: "GetOneTimeToken",
  options: {
    "google.api.http": {
      post: "/grpc-json/txauth/v3/getonetimetoken",
      body: "*"
    }
  },
  I: GetOneTimeTokenRequest,
  O: GetOneTimeTokenResponse
}, {
  name: "ExchangeOneTimeToken",
  options: {
    "google.api.http": {
      post: "/grpc-json/txauth/v3/exchangeonetimetoken",
      body: "*"
    }
  },
  I: ExchangeOneTimeTokenRequest,
  O: ExchangeOneTimeTokenResponse
}, {
  name: "GetAutologinUrl",
  options: {
    "google.api.http": {
      get: "/grpc-json/txauth/v3/autologin"
    }
  },
  I: AutologinRequest,
  O: AutologinResponse
}]);